import tw from 'twin.macro';

const Card = tw.div`flex flex-wrap`;

export default Card;
